import React from "react"
import { Grid, Typography, Link } from "@material-ui/core"

import { ActionDialog } from "@/components"
import { MessageWasteTipsIcon } from "@/assets/icons"
import { colors } from "@/styles/colors"
import { WABALinks } from "@/utils/link"

export const openMessageWasteTipsModal = () => {
	ActionDialog.open({
		title: (
			<Typography variant="h6" style={{ fontWeight: 700 }}>
				Como evitar desperdício de mensagens
			</Typography>
		),
		dialogTitleIcon: (
			<MessageWasteTipsIcon style={{ width: 19, height: 19, color: colors.purple[600] }} />
		),
		openDialog: true,
		maxWidth: "sm",
		hideCloseButton: true,
		saveText: "ENTENDI",
		forcedRender: true,
		onSave: () => undefined,
		children: (
			<Grid container direction="column" spacing={2} key="message-waste-tips">
				<Grid item>
					<Typography variant="body2">
						Nesta conversa o modo Meta: custo reduzido não está ativado, então cada mensagem de serviço enviada tem custo da Meta.
					</Typography>
				</Grid>

				<Grid item>
					<Typography variant="body2" component="ul" style={{ paddingLeft: 20, margin: 0 }}>
						<li>Escreva a resposta completa em uma única mensagem. Cada mensagem enviada é cobrada, então três mensagens curtas custam três vezes mais que uma bem escrita.</li>
						<li>Evite mandar saudação, pergunta e informação em balões separados. Use listas e quebras de linha dentro do mesmo balão.</li>
						<li>Prefira reunir dúvidas antes de responder, em vez de enviar uma mensagem a cada pensamento.</li>
						<li>Anúncios Click to Whatsapp (CTW) da Meta abrem 7 dias de custo reduzido nas mensagens de serviço. Direcionar campanhas por ali derruba o custo do atendimento.</li>
					</Typography>
				</Grid>

				<Grid item>
					<Link href={WABALinks.metaFreeEntryPointWindowHelpArticle} target="_blank" rel="noopener noreferrer">
						Como funciona o modo Meta: custo reduzido
					</Link>
				</Grid>
			</Grid>
		)
	})
}
